<template>
  <div class="cursos">
    <Header/>
      <div class="body">
        <div class="sobre">
          <h2> <font-awesome-icon icon="book" class="icon_spot"/> Cursos Modulares </h2> <br>
          <div>
            <b-tabs content-class="mt-3" fill>
              <b-tab title="Redação" active>
                <div class="div_tam">
                  <h4 class="p_sobre">Redação</h4>
                  <p class="p_sobre">O mais conhecido curso de Redação da Baixada Santista!! Nele, a Professora e Mestra pela USP, Eliane, trabalhará <b>Filosofia, Sociologia, História da Arte e Literatura aplicadas ao texto</b>. Você aprenderá COMO construir a estrutura de todos os gêneros cobrados pelo vestibular: dissertação, carta, artigo de opinião, verbete, manifesto, relato...</p>
                  <p class="p_sobre">Neste curso, você poderá contar também com uma ENORME EQUIPE DE CORREÇÃO, com corretores especializados em cada vestibular que você for prestar. Receberá suas redações corrigidas rapidamente, com uma correção detalhada no modelo escolhido por você. Nossos corretores sempre trarão COMENTÁRIOS ESPECÍFICOS SOBRE SEU TEXTO E DICAS DE COMO VOCÊ DEVE MELHORAR.</p>
                </div>
              </b-tab><!--
              <b-tab title="Humanidades">
                <div class="div_tam">
                  <h4 class="p_sobre">Humanidades</h4>
                  <p class="p_sobre">Quer um curso interdisciplinar que te ajude a pensar as humanas todas juntas? <b>Filosofia, Sociologia, Interpretação de texto, História e Gramática</b> em um só curso!! Venha se preparar para fazer com tranquilidade as questões da UNICAMP e do ENEM, vá para os vestibulares da UFPR e da UEL sem medo!!</p>
                </div>
              </b-tab>
              <b-tab title="Biologia">
                <div class="div_tam">
                  <h4 class="p_sobre">Biologia</h4>
                  <p class="p_sobre">Quer medicina e precisa GABARITAR BIOLÓGICAS? Tem QUESTÃO DISSERTATIVA DE BIOLOGIA no seu vestibular e você está com medo? Venha fazer nosso curso modular de Biologia com um PROFESSOR ESPECIALISTA NAS SEGUNDAS FASES, NAS PROVAS DA <b> VUNESP</b> E NA DA <b>UNILUS</b>!!</p>
                </div>
              </b-tab>
              <b-tab title="Física">
                <div class="div_tam">
                  <h4 class="p_sobre">Física</h4>
                  <p class="p_sobre">	Você tem medo de Física e sente que nunca aprendeu direito essa matéria? Venha ver TUDO DO COMEÇO no nosso modular de Física e desmistifique essa disciplina de uma vez!!</p>
                </div>
              </b-tab>-->
              <b-tab title="Matemática">
                <div class="div_tam">
                  <h4 class="p_sobre">Matemática</h4>
                  <p class="p_sobre">Pare de ter medo da Matemática e venha aprender todo o conteúdo – do básico ao avançado – que você precisa para o vestibular!! O nosso modular de Matemática é o mais COMPLETO, englobando as áreas de Álgebra, Geometria e Trigonometria!! </p>
                </div>
              </b-tab>
              <b-tab title="Química">
                <div class="div_tam">
                  <h4 class="p_sobre">Química</h4>
                  <p class="p_sobre">Se você está buscando um curso de Química completo e que te faça entender a Química como um todo, sem decorar fórmulas ou separar as áreas, você chegou ao lugar certo!! O Cursinho Sapiência prioriza a CONSTRUÇÃO DO CONHECIMENTO e não, fórmulas prontas que você pode esquecer na hora da prova!! Venha pensar a Química com a gente!! </p>
                </div>
              </b-tab><!--
              <b-tab title="Literatura">
                <div class="div_tam">
                  <h4 class="p_sobre">Literatura</h4>
                  <p class="p_sobre"> Acha que Literatura é decorar obras e estéticas literárias? Então você PRECISA do nosso curso modular COMPLETO de Literatura, onde você aprende a IDENTIFICAR NO TEXTO qual autor escreveu e a qual estética este pertence!! Venha entender COMO funciona de fato uma análise literária e COMO pensamos os períodos literários e momentos históricos!! Venha aprender o que pensam os críticos literários para que você esteja atualizado para qualquer vestibular!! Não deixe essa oportunidade passar!! </p>
                </div>
              </b-tab>-->
              <b-tab title="Obras Literárias">
                <div class="div_tam">
                  <h4 class="p_sobre">Obras Literárias</h4>
                  <p class="p_sobre"> Seu sonho é FUVEST e UNICAMP? Então venha para o Sapi e faça o curso que te prepara 100% para lidar com os livros obrigatórios das listas desses vestibulares! Esteja pronto para gabaritar, inclusive as questões dissertativas. As aulas abordarão o jeito de pensar das universidades, possíveis questões, contextos históricos e se aprofundarão nas análises literárias. Se você quer receber a aprovação das maiores universidades de São Paulo, esse é seu curso! </p>
                </div>
              </b-tab>
              <b-tab title="Física">
                <div class="div_tam">
                  <h4 class="p_sobre">Física</h4>
                  <p class="p_sobre"> Agora você não precisa ficar apavorado quando tiver que responder questões de Física. O modular de Física te prepara para qualquer prova, das mais fáceis às mais difíceis, te ensinando como interpretar questões e reconhecer as fórmulas envolvidas. Abordando todas as frentes, elétrica e mecânica, você conseguirá resolver qualquer desafio com facilidade.</p>
                </div>
              </b-tab>
              <b-tab title="Biologia">
                <div class="div_tam">
                  <h4 class="p_sobre">Biologia</h4>
                  <p class="p_sobre"> Quer gabaritar em biologia? Então você veio ao lugar certo. O curso modular de biologia tem um currículo completo que vai te dar total respaldo nos vestibulares; abordando genética, evolução, ecologia, citologia, entre outros temas da área... Com a junção de conceito e exercício, você nunca mais vai errar nessa disciplina.</p>
                </div>
              </b-tab>
              <b-tab title="Humanidades">
                <div class="div_tam">
                  <h4 class="p_sobre">Humanidades</h4>
                  <p class="p_sobre"> Uma disciplina extremamente completa que abordará história, cultura e humanidade, te enriquecendo não somente para o vestibular, mas também te dando repertório cultural para a diversas situações. O modular de humanidades incluirá história, geografia, literatura e gramática, dando um panorama completo para construção do senso crítico e aprofundamento dos conhecimentos exigidos para toda e qualquer prova. </p>
                </div>
              </b-tab>
              <b-tab title="Projeto Canguru">
                <div class="div_tam">
                  <h4 class="p_sobre">Projeto Canguru</h4>
                  <p class="p_sobre"> O projeto canguru vai em busca da sua aprovação junto com você. O projeto em si, elaborado pela professora Eliane Limonti, oferece aos alunos um acompanhamento individual, e próximo, do desenvolvimento e da rotina de estudos de cada vestibulando. Cada estudante tem seu tutor e este irá oferecer todo o suporte apresentando métodos de estudo, elaborando rotinas, listas extras e esclarecendo o funcionamento de cada vestibular e/ou faculdade. O projeto acredita que o aprendizado deve ser assistido e o acompanhamento feito de perto, em parceria.</p>
                </div>
              </b-tab>
            </b-tabs>
          </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default{
  components:{
    Header,
    Footer
  }
}
</script>

<style>
@import "../assets/style_padrao.css";
  .div_tam{
    min-height:30vh;
    height:auto;
  }
  #t{
    position: absolute;
    left: 35%;
    bottom: 75%;
    z-index: 1000;
    background: #7435af;
    margin: auto;
    border-radius: 20px;
    padding: 2% 5%;
    width: fit-content;
  }
  #a{
    position: relative;
    padding-top: 7%;
    border-radius: 25px;
    background:white;
    box-shadow: 2px 3px 18px #adadad;
  }
  #sap_aluno{
    width: 100%;
    margin-bottom: 5%;
  }
  #ast{
    color:red;
  }
  h1{
    text-align: center;
  }
  h2{
    text-align: center;
  }
  .p_sobre{
    margin-left: 4%;
    margin-right: 4%;
    text-align: justify!important;
    color: #4F4F4F;
  }
  #msg{
    text-align: center;
  }
  @media only screen and (max-width: 450px) {
    .p_sobre{
      text-align:left!important;
    }
  }
</style>
